var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddTicketLineNote = function SvgAddTicketLineNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.50195C3.68629 3.50195 1 6.18825 1 9.50195V17.502C1 20.8157 3.68629 23.502 7 23.502H7.48306L7.52064 27.6661C7.52065 28.6661 8.74373 28.6661 9.24372 28.1812L13.4224 23.502H25C28.3137 23.502 31 20.8157 31 17.502V9.50195C31 6.18825 28.3137 3.50195 25 3.50195H7Z",
    fill: "currentColor"
  })));
};
export default SvgAddTicketLineNote;